(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["juha-collection"] && !Shopify.designMode) return;
  try {
    
window.juhaCollectionLook = [
  {
    "look": 1,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_1_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_1_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_1_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230301-1",
        "name": "PINSTRIPE STRUCTURED JACKET",
        "color": "NAVY"
      },
      {
        "id": "No.10230701",
        "name": "FLORAL BOWTIE SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10230802-1",
        "name": "EXTREME WIDE PINSTRIPE PANTS",
        "color": "NAVY"
      }
    ]
  },
  {
    "look": 2,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_2_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_2_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_2_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230102",
        "name": "BELTED SHORT TRENCH",
        "color": "BLACK"
      },
      {
        "id": "No.10230703-4",
        "name": "SHEER LIGHT SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10230808",
        "name": "SECOND SKIN HALF LEGGINGS",
        "color": "CHARCOAL"
      }
    ]
  },
  {
    "look": 3,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_3_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_3_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_3_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230301-1",
        "name": "PINSTRIPE STRUCTURED JACKET",
        "color": "CHARCOAL"
      },
      {
        "id": "No.10230703-4",
        "name": "SHEER LIGHT SHIRT",
        "color": "WHITE"
      }
    ]
  },
  {
    "look": 4,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_4_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_4_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_4_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230201",
        "name": "OVER SLEEVE BOMBER JACKET",
        "color": "NAVY"
      },
      {
        "id": "No.10230703-1",
        "name": "FLORAL SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10230804-1",
        "name": "2TUCK EASY SHORTS",
        "color": "NAVY"
      }
    ]
  },
  {
    "look": 5,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_5_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_5_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_5_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230703-4",
        "name": "SHEER LIGHT SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10230703-4",
        "name": "SHEER LIGHT SHIRT",
        "color": "SAX"
      },
      {
        "id": "No.10230808",
        "name": "SECOND SKIN HALF LEGGINGS",
        "color": "ECRU"
      }
    ]
  },
  {
    "look": 6,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_6_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_6_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_6_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230605-1",
        "name": "SIGNATURE SKIN TEE",
        "color": "CHARCOAL"
      },
      {
        "id": "No.10230704-3",
        "name": "COMPACT TWILL S/S SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10230801-2",
        "name": "2TUCK WIDE SUMMER TWEED PANTS",
        "color": "CHARCOAL"
      }
    ]
  },
  {
    "look": 7,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_7_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_7_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_7_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230602",
        "name": "SUMMER TWEED P/O VEST",
        "color": "NAVY"
      },
      {
        "id": "No.10230605-1",
        "name": "SIGNATURE SKIN TEE",
        "color": "CHARCOAL"
      },
      {
        "id": "No.10230704-3",
        "name": "COMPACT TWILL S/S SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10230801-2",
        "name": "2TUCK WIDE SUMMER TWEED PANTS",
        "color": "NAVY"
      }
    ]
  },
  {
    "look": 8,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_8_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_8_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_8_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230202-2",
        "name": "SOFT SHELL JACKET",
        "color": "CHARCOAL"
      },
      {
        "id": "No.10230703-2",
        "name": "FEATHER LACE SHIRT",
        "color": "ECRU"
      },
      {
        "id": "No.10230804-1",
        "name": "2TUCK EASY SHORTS",
        "color": "BROWN"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 9,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_9_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_9_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_9_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230101",
        "name": "LEATHER - COLLAR BALMACAAN COAT",
        "color": "BLACK"
      },
      {
        "id": "No.10230701",
        "name": "FLORAL BOWTIE SHIRT",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 10,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_10_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_10_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_10_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230101",
        "name": "LEATHER - COLLAR BALMACAAN COAT",
        "color": "BEIGE"
      },
      {
        "id": "No.10230605-2",
        "name": "PILE SKIN TEE",
        "color": "ECRU"
      },
      {
        "id": "No.10230703-3",
        "name": "COMPACT TWILL SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10230808",
        "name": "SECOND SKIN HALF LEGGINGS",
        "color": "ECRU"
      }
    ]
  },
  {
    "look": 11,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_11_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_11_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_11_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230301-1",
        "name": "PINSTRIPE STRUCTURED JACKET",
        "color": "NAVY"
      },
      {
        "id": "No.10230605-2",
        "name": "PILE SKIN TEE",
        "color": "BLACK"
      },
      {
        "id": "No.10230703-4",
        "name": "SHEER LIGHT SHIRT",
        "color": "SAX"
      },
      {
        "id": "No.10230808",
        "name": "SECOND SKIN HALF LEGGINGS",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 12,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_12_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_12_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_12_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230703-4",
        "name": "SHEER LIGHT SHIRT",
        "color": "SAX"
      },
      {
        "id": "No.10230807",
        "name": "DENIM HALF SHORTS",
        "color": "FADE BLACK"
      },
      {
        "id": "No.10230802-2",
        "name": "EXTREME WIDE EASY PANTS",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 13,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_13_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_13_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_13_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230301-2",
        "name": "STRUCTURED DOUBLE JACKET",
        "color": "BLACK"
      },
      {
        "id": "No.10230605-3",
        "name": "SIGNATURE TEE",
        "color": "CHARCOAL"
      },
      {
        "id": "No.10230703-3",
        "name": "COMPACT TWILL SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10230807",
        "name": "DENIM HALF SHORTS",
        "color": "FADE BLACK"
      },
      {
        "id": "No.10230802-2",
        "name": "EXTREME WIDE EASY PANTS",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 14,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_14_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_14_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_14_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230601",
        "name": "CROP ZIP HOODIE",
        "color": "CHARCOAL"
      },
      {
        "id": "No.10230703-4",
        "name": "SHEER LIGHT SHIRT",
        "color": "SAX"
      },
      {
        "id": "No.10230802-1",
        "name": "EXTREME WIDE PINSTRIPE PANTS",
        "color": "CHARCOAL"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 15,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_15_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_15_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_15_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230302-1",
        "name": "SUMMER TWEED TAILORED JACKET",
        "color": "NAVY"
      },
      {
        "id": "No.10230703-4",
        "name": "SHEER LIGHT SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10230808",
        "name": "SECOND SKIN HALF LEGGINGS",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 16,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_16_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_16_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_16_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230702-1",
        "name": "PINSTRIPE WESTERN SHIRT",
        "color": "NAVY"
      },
      {
        "id": "No.10230802-1",
        "name": "EXTREME WIDE PINSTRIPE PANTS",
        "color": "NAVY"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 17,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_17_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_17_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_17_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230603-1",
        "name": "SHEER VELOUR SKIN HENLEY",
        "color": "ECRU"
      },
      {
        "id": "No.10230703-4",
        "name": "SHEER LIGHT SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10230804-1",
        "name": "2TUCK EASY SHORTS",
        "color": "BROWN"
      }
    ]
  },
  {
    "look": 18,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_18_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_18_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_18_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230701",
        "name": "FLORAL BOWTIE SHIRT",
        "color": "WHITE"
      },
      {
        "id": "No.10230804-2",
        "name": "FLORAL EASY SHORTS",
        "color": "WHITE"
      },
      {
        "id": "No.10230807",
        "name": "BALLOON DENIM PANTS",
        "color": "LIGHT INDIGO"
      }
    ]
  },
  {
    "look": 19,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_19_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_19_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_19_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230704-2",
        "name": "FEATHER LACE S/S SHIRT",
        "color": "BROWN"
      },
      {
        "id": "No.10230704-2",
        "name": "FEATHER LACE S/S SHIRT",
        "color": "ECRU"
      },
      {
        "id": "No.10230807",
        "name": "DENIM HALF SHORTS",
        "color": "LIGHT BROWN"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 20,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_20_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_20_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_20_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230602",
        "name": "SUMMER TWEED P/O VEST",
        "color": "BLACK"
      },
      {
        "id": "No.10230701",
        "name": "FLORAL BOWTIE SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10230804-2",
        "name": "FLORAL EASY SHORTS",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 21,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_21_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_21_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_21_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230302-1",
        "name": "SUMMER TWEED TAILORED JACKET",
        "color": "NAVY"
      },
      {
        "id": "No.10230202-2",
        "name": "SOFT SHELL JACKET",
        "color": "CHARCOAL"
      },
      {
        "id": "No.10230808",
        "name": "SECOND SKIN HALF LEGGINGS",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 22,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_22_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_22_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_22_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230703-2",
        "name": "FEATHER LACE SHIRT",
        "color": "ECRU"
      },
      {
        "id": "No.10230703-4",
        "name": "SHEER LIGHT SHIRT",
        "color": "BLACK"
      },
      {
        "id": "No.10230804-1",
        "name": "2TUCK EASY SHORTS",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 23,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_23_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_23_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_23_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230302-1",
        "name": "SUMMER TWEED TAILORED JACKET",
        "color": "BLACK"
      },
      {
        "id": "No.10230101",
        "name": "LEATHER - COLLAR BALMACAAN COAT",
        "color": "BLACK"
      },
      {
        "id": "No.10230801-2",
        "name": "2TUCK WIDE SUMMER TWEED PANTS",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 24,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_24_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_24_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_24_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230102",
        "name": "BELTED SHORT TRENCH",
        "color": "BEIGE"
      }
    ]
  },
  {
    "look": 25,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_25_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_25_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_25_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230603-1",
        "name": "SHEER VELOUR SKIN HENLEY",
        "color": "BLACK"
      },
      {
        "id": "No.10230703-4",
        "name": "SHEER LIGHT SHIRT",
        "color": "SAX"
      },
      {
        "id": "No.10230802-2",
        "name": "EXTREME WIDE EASY PANTS",
        "color": "BLACK"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  },
  {
    "look": 26,
    "images": {
      "small": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_26_480.jpg",
      "medium": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_26_800.jpg",
      "large": "https://cdn.shopify.com/s/files/1/0466/7142/9796/files/look2026ss_26_1520.jpg"
    },
    "items": [
      {
        "id": "No.10230201",
        "name": "OVER SLEEVE BOMBER JACKET",
        "color": "NAVY"
      },
      {
        "id": "No.10230703-4",
        "name": "SHEER LIGHT SHIRT",
        "color": "SAX"
      },
      {
        "id": "No.10230805",
        "name": "HIGHTWISTED CARGO PANTS",
        "color": "NAVY"
      },
      {
        "id": "No.10220903",
        "name": "SILK NARROW TIE",
        "color": "BLACK"
      }
    ]
  }
];

    document.addEventListener('DOMContentLoaded', function() {
      var $videoBtn = document.querySelector('.p-juhaCollection__videoPlaybtn');

      if ($videoBtn) {
        $videoBtn.addEventListener('click', function() {
          var $video = document.querySelector('.p-juhaCollection__video');
          var $iframe = $video.querySelector('iframe');

          $video.classList.add('is-play');
          videoControl('playVideo', $iframe);
        });
      }

      function videoControl(action, tgt){
        var $playerWindow = tgt.contentWindow;

        $playerWindow.postMessage('{"event":"command","func":"'+action+'","args":""}', '*');
      }

      var collectionHtml = '';
      window.juhaCollectionLook.forEach(function (look) {
        var itemsHtml = '';
        look.items.forEach(function(item) {
          var heading = '';
          if (item.heading) {
            heading = item.heading + '<br>';
          }
          itemsHtml += '<li>' + heading + item.id + '<br>' + item.name + '<br>' + item.color + '</li>';
        });
        collectionHtml += '<div class="p-juhaCollection__item"><div class="p-juhaCollection__pic"><img srcset="' + look.images.small + ' 480w, ' + look.images.medium + ' 800w, ' + look.images.large + ' 1520w" src="' + look.images.large + '" sizes="(max-width:750px) 100vw, (max-width:990px) 50vw, 33vw"></div><div class="p-juhaCollection__info"><div class="p-juhaCollection__body"><ul>' + itemsHtml + '</ul></div></div></div>'
      });
      var $elm = document.getElementById('p-juhaCollection__items');
      $elm.innerHTML = collectionHtml;
    });

  } catch(e) { console.error(e); }
})();
})();
